import React from 'react';

import ImagesByRoom from '../../ImagesVideo/ImagesByRoom';
import type { PropertyRoomTypeWithImages } from '../../ImagesVideo/types';
import type { OfferBuilderMediaController } from '../../useOfferBuilderMedia';

interface Props {
  media: OfferBuilderMediaController;
  onOpenImagesVideo: () => void;
  propertyRoomTypes: Array<PropertyRoomTypeWithImages>;
  roomKey: string;
}

export default function ImagesTab({ media, onOpenImagesVideo, propertyRoomTypes, roomKey }: Props) {
  return (
    <ImagesByRoom
      excludedImagePublicIds={media.deletedImagePublicIds}
      hiddenImagePublicIds={media.hiddenImagePublicIds}
      imagePublicIdReplacements={media.imagePublicIdReplacements}
      isMetadataEditable
      mediaImages={media.mediaImages}
      onEditImage={media.editRoomImage}
      onOpenImagesVideo={onOpenImagesVideo}
      onRemoveImageFromRoom={media.removeImageFromRoom}
      onReorderRoomImages={media.reorderRoomImages}
      onToggleHiddenImage={media.toggleHiddenImage}
      onUpdateImageTitle={media.updateImageTitle}
      onUploadImagesToRoom={media.uploadFilesToRoom}
      propertyRoomTypes={propertyRoomTypes}
      roomImageOrderOverrides={media.roomImageOrderOverrides}
      showHeader={false}
      showRoomDetails={false}
      uploadedRoomAssignments={media.uploadedRoomAssignments}
      visibleRoomKeys={[roomKey]}
    />
  );
}
